export default {
  cdn: 'http://cdn-prod.buoyweather.com/webapp/',
  bwHost: 'http://www.buoyweather.com',
  bwHostBeanstalk: 'http://bw-web-prod.elasticbeanstalk.com',
  cmsCdn: 'http://cdn-prod.buoyweather.com/uploads',
  servicesURL: 'https://services.surfline.com',
  bwServicesURL: 'http://services.buoyweather.com',
  geotargetService: 'http://geo-target-service.prod.surfline.com',
  bwApiUrl: 'https://www.buoyweather.com',
  legacyUrl: 'http://www.buoyweather.com',
  appKeys: {
    segment: 'CvbvzychXPuprLT31PUJjn2797aKS8Ez',
    newrelic: '',
    splitio: process.env.SPLITIO_AUTHORIZATION_KEY || 'in20v2ebf6q1gh97ldcn1bp8ufdbr404e514',
  },
  links: {
    funnel: {
      login: 'https://www.buoyweather.com/sign-in',
      logout: 'http://www.buoyweather.com/sign-out',
      try_premium_mobile: 'https://www.buoyweather.com/upgrade/',
      try_premium: 'https://www.buoyweather.com/upgrade/',
      registerNow: 'https://www.buoyweather.com/upgrade/',
      renew: 'https://www.buoyweather.com/upgrade/',
    },
    account: {
      information: 'https://www.buoyweather.com/account/',
      payment: 'https://www.buoyweather.com/account/',
      contact: 'http://www.buoyweather.com/info.jsp?id=21736',
    },
  },
};



// WEBPACK FOOTER //
// ./src/config/envs/production.js